import {version} from '../utils/util.js'

/**
 * 安卓注册函数
 */
function connectWebViewJavascriptBridgeANDROID(callback) {
    if (window && window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge)
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function () {
            callback(window.WebViewJavascriptBridge)
        }, false)
    }
}

connectWebViewJavascriptBridgeANDROID(function (bridge) {
        //安卓端，接收数据时，需要先进行初始化
        bridge.init(function (message, responseCallback) {
            const data = {
                'Javascript Responds': 'Wee!'
            };
            responseCallback(data);
        })
    }
)

/**
 * ios注册函数
 */
function connectWebViewJavascriptBridgeIOS(callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
    }, 0)
}

export const bridge = {
    callhandler (name, data) {
        return new Promise((resolve, reject) => {
            if(version().ios) {
                connectWebViewJavascriptBridgeIOS(function (bridge) {
                    bridge.callHandler(name, data, (responseData) => {
                        resolve(responseData)
                    })
                })
            } else if(version().android) {
                setTimeout(() => {
                    connectWebViewJavascriptBridgeANDROID((bridge) => {
                        if(bridge) {
                            if(data instanceof Object) {
                                data = JSON.stringify(data)
                            }
                            bridge.callHandler(name, data, (responseData) => {
                                try {
                                    if(typeof responseData === 'string') {
                                        responseData = JSON.parse(responseData)
                                    }
                                    resolve(responseData)
                                } catch(err) {
                                    resolve(responseData)
                                }
                            })
                        } else {
                            reject({type: 1, message: '非WebViewJavascriptBridge环境', bridge: !!bridge})
                        }
                    })
                }, 300)

            } else {
                reject({type: 2})
            }
        })
    },
    registerhandler (name) {
        return new Promise((resolve, reject) => {
            if(version().ios) {
                connectWebViewJavascriptBridgeIOS(function (bridge) {
                    bridge.registerHandler(name, function (data, responseCallback) {
                        resolve({
                            data,
                            responseCallback
                        })
                    })
                })
                setTimeout(() => {
                    reject({type: 3})
                }, 500)
            } else if(version().android) {
                connectWebViewJavascriptBridgeANDROID(function(bridge) {
                    if(bridge) {
                        bridge.registerHandler(name, function(data, responseCallback) {
                            try {
                                if(typeof data === 'string') {
                                    data = JSON.parse(data)
                                }
                                resolve(data, responseCallback)
                            } catch(err) {
                                resolve(data, responseCallback)
                            }
                        })
                    } else {
                        reject({type: 1})
                    }
                })
            } else {
                reject({type: 2})
            }
        })

    }
}

/**
 * type 为返回异常类型
 * 1：安卓环境且无WebViewJavascriptBridge对象
 * 2：非安卓和ios环境
 * 3：ios环境但无bridge环境
 */

export default {
    install(Vue) {
        Vue.prototype.$bridge = bridge
    }
}
